import { createAsyncThunk } from "@reduxjs/toolkit";
import newsApi from 'api/newsApi';
import { formatQueryParams } from "helpers/format";

export const getListNews = createAsyncThunk("List News", async (params: any = {}) => {
  try {
    const response = await newsApi.aiNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getAINewsByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.aiNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getPostByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.posts(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getCommentByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.comments(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getMyNewsByNormal = async (params: any = {}) => {
  try {
    const response = await newsApi.myNews(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.news(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const putNews = async (id: number | string, data: any = {}) => {
  try {
    const response = await newsApi.putNews(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const downloadNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.downloadNews(id, formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const publishNews = async (id: string | number, data: any = {}) => {
  try {
    const response = await newsApi.publishNews(id, formatQueryParams(data))
    return response;
  } catch (error) {
    return error;
  }
};


export const cancelMyNews = async (id: string | number, params: any = {}) => {
  try {
    const response = await newsApi.cancelMyNews(id, formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};


export const checkCurrentUsageNews = async (params: any = {}) => {
  try {
    const response = await newsApi.checkCurrentUsageNews(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const publishPressconNews = async (id: string | number, data: any = {}) => {
  try {
    const response = await newsApi.publishPressconNews(id, formatQueryParams(data))
    return response;
  } catch (error) {
    return error;
  }
};

export const postCreateUsingAINews = async (data: any = {}) => {
  try {
    const response = await newsApi.postCreateUsingAINews(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const actionPost = async (id: string | number, data: any = {}) => {
  try {
    const response = data?.type === "RUN" ? await newsApi.actionRunPost(id, {}) : await newsApi.actionCancelPost(id, {})
    return response;
  } catch (error) {
    return error;
  }
};

export const createPost = async (data: any = {}) => {
  try {
    const response = await newsApi.createPost(data);
    return response;
  } catch (error) {
    return error;
  }
};